import { ShieldCheck } from "lucide-react";

export const PriceBands = ({ tiers, scope }) => {
  if (!tiers?.length) return null;
  return (
    <section data-testid="price-bands" className="mt-9 border border-line bg-white">
      <div className="flex items-center gap-2.5 px-6 md:px-7 pt-5 pb-1">
        <ShieldCheck size={13} className="text-sage-dark" />
        <span className="text-[10px] tracking-[0.2em] uppercase text-[#6E6A63]">
          What people typically spend
        </span>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-line mt-3">
        {tiers.map((t) => (
          <div key={t.label} className="bg-white px-6 md:px-7 py-5">
            <div className="text-[11px] tracking-[0.12em] uppercase text-[#3F3F3F] font-medium">{t.label}</div>
            <div className="display font-semibold text-[19px] md:text-[21px] leading-tight text-charcoal mt-2">
              {t.range}
            </div>
            {t.note && (
              <div className="text-[17px] md:text-[18px] leading-[1.5] text-[#3F3F3F] mt-2.5">{t.note}</div>
            )}
          </div>
        ))}
      </div>
      {scope && (
        <p
          data-testid="price-scope"
          className="text-[12px] font-light leading-[1.6] text-[#6E6A63] px-6 md:px-7 py-4 border-t border-line"
        >
          {scope} Ranges are guidance, not quotes. Verified 6 September 2026.
        </p>
      )}
    </section>
  );
};
